import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { containerStyles } from "./TextInputWrapper.styles.js";
import { FormControl } from "../../components/FormControl/FormControl.js";
import { FormLabel } from "../../components/FormLabel/FormLabel.js";
import { FormHelperText } from "../../components/FormHelperText/FormHelperText.js";
const TextInputWrapper = ({
  FormHelperTextProps,
  helperText,
  InputLabelProps,
  label,
  error = false,
  disabled = false,
  className,
  fullWidth,
  children,
  inputLabelId,
  helperTextId,
  userClassName,
  id,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(FormControl, { css: containerStyles, className: clsx(className, fullWidth && "Ascend-fullWidth", userClassName), ...props, children: [
    label != null && label !== "" && /* @__PURE__ */ jsx(FormLabel, { className: clsx(userClassName && `Ascend-inputLabel-${userClassName}`), error, disabled, htmlFor: id, id: inputLabelId, ...InputLabelProps, children: label }),
    children,
    helperText && /* @__PURE__ */ jsx(FormHelperText, { className: clsx(userClassName && `Ascend-helperText-${userClassName}`), error, id: helperTextId, disabled, ...FormHelperTextProps, children: helperText })
  ] });
};
export {
  TextInputWrapper
};
//# sourceMappingURL=TextInputWrapper.js.map
